module.exports = __webpack_public_path__ + "4e878f3e.svg";